export default __webpack_public_path__ + "images/FL.822a47e.png";